import AFRAME from "aframe";
import jQuery from "jquery";

const $ = jQuery;

AFRAME.registerComponent('auto-rotate', {
    schema: {
        speed: {type: 'number', default: 0.01}
    },
    tick: function() {
        this.el.object3D.rotateY(this.data.speed);
    }
});

AFRAME.registerComponent('advanced-visible', {
    dependencies: ['visible'],
    schema: {
        type: 'boolean', default: true
    },
    init: function () {
        const me = this;
    },
    update: function() {
        const me = this;

        if (me.data) {
            me.el.setAttribute('scale', {x: 1, y: 1, z: 1});
            me.el.setAttribute('visible', true);

            if (me.el.classList.contains("clickable-disabled")) {
                me.el.classList.remove("clickable-disabled");
                me.el.classList.add("clickable");
            }
        } else {
            me.el.setAttribute('visible', false);
            me.el.setAttribute('scale', {x: 0, y: 0, z: 0});

            if (me.el.classList.contains("clickable")) {
                me.el.classList.remove("clickable");
                me.el.classList.add("clickable-disabled");
            }
        }
    }
});

AFRAME.registerComponent('exit-vr-button', {
    init: function () {
        const me = this;
        this.el.addEventListener('click', function () {
            me.el.sceneEl.exitVR();
        });
    }
});

AFRAME.registerComponent('push-mesh-backwards', {
    schema: {
        distance: {type: 'number', default: 0.05}
    },
    init: function () {
        this.el.getObject3D('mesh').position.set(0, 0, -this.data.distance);
    }
});

AFRAME.registerComponent('play-sound', {
    schema: {
        audio: {type: 'selector', default: ''},
        events: {type: 'array', default: 'click'},
    },
    multiple: true,
    init: function () {
        const me = this;

        for (let event of me.data.events) {
            me.el.addEventListener(event, function (event) {
                me.data.audio.play();
            });
        }
    }
});